/**
 * Bug Tracking API Client
 * Endpoints for bug report submission and beta tester access.
 */
import { api } from './client';

export const bugsApi = {
  /**
   * Submit a bug report
   * @param {Object} bugData - Bug report data with screenshot, logs, etc.
   */
  submit: (bugData) => api.post('/bugs', bugData),

  /**
   * Check if current user has beta tester access
   */
  checkBetaAccess: () => api.get('/users/me/beta-status')
};
